// src/kunde/ui.js
// Beskeder og dialoger i kunde-appen.
//
// Ligger her og ikke i src/lib, fordi de to apper bruger hver sin
// konvention: kunde-appen åbner dialoger med klassen "open" og lukker
// baggrunden via ".overlay", mens admin-panelet bruger "on" og
// ".modal-bg". At dele koden ville kræve at man først gjorde markup'en
// ens — og det hører til i den kommende designomlægning.

import { opretAuthFetch } from '../lib/api.js';
import { sb } from '../lib/supabase.js';

export const authFetch = opretAuthFetch(sb);

export function closeModal(id) {
  document.getElementById(id).classList.remove('open');
}

let toastTimer;
export function toast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 3200);
}

/** Luk en dialog ved klik uden for indholdet. Kaldes fra main.js. */
export function initDialoger() {
  document.querySelectorAll('.overlay').forEach(o => {
    o.addEventListener('click', e => {
      if (e.target === o) o.classList.remove('open');
    });
  });
}
